import React from 'react'
import styled from 'styled-components';
import BookSourceSection from "./common/BookSourceSection";
import useBookSubscription from "../hooks/useBookSubscription";
import RowSpacer from "../../../../common/styles/RowSpacer";
import ContentContainer from "../../../../common/styles/ContentContainer";
import ColSpacer from "../../../../common/styles/ColSpacer";
import BookSourceNoContent from "../BookSourceNoContent";
import BookSourceSectionLoading from "./common/BookSourceSectionLoading";

interface Props {
    isbn: string
}

const BookSourceSubscriptionSection: React.FC<Props> = ({isbn}) => {
    const [subscriptions, isSubscriptionLoading] = useBookSubscription(isbn ?? '')

    return (
        <BookSourceSection
            title={`구독 서비스`}
            isEmpty={isSubscriptionLoading ? false : subscriptions.length === 0}
            // @ts-ignore
            body={
                isSubscriptionLoading || subscriptions == null ?
                    <BookSourceSectionLoading/>
                    :
                    <Body subscriptions={subscriptions}/>
            }
        />
    )
}

interface BodyProps {
    subscriptions: BookSubscriptionResponse[]
}

const Body: React.FC<BodyProps> = ({subscriptions}) => {
    if (subscriptions.length == 0) {
        return <BookSourceNoContent message={'구독 서비스에는 책이 없어요'}/>
    }

    return (
        <>
            {
                subscriptions.map(subscription => {
                    return (
                        <div className={'hover-effect'}>
                            <a href={subscription.link!!} target={'_blank'}>
                                <RowSpacer size={10}/>
                                <ContentContainer>
                                    <div>
                                        <span className={'d-flex'}>
                                            <Icon src={subscription.imageUrl}/>
                                            <ColSpacer size={5}/>
                                            <h6 className={'p-0 m-0 pt-1 text'}>{subscription.label}</h6>
                                        </span>
                                    </div>
                                </ContentContainer>
                            </a>
                        </div>
                    )
                })
            }
        </>
    );
}

const Icon = styled.img.attrs({
    className: 'rounded'
})`
    width: 30px;
    height: 30px;
`

interface BookSubscriptionResponse {
    link: string
    provider: string
    label: string
    imageUrl: string
}

export default BookSourceSubscriptionSection
